import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

/**
 * Fetches time-limited coturn credentials for WebRTC TURN server authentication
 *
 * @param organizationId - The organization's unique identifier
 * @returns CoturnCredentials with username, password, ttl, and server URLs
 */
export const getCoturnCredentialsThunk = createAppAsyncThunk(
  'organization/getCoturnCredentials',
  async(organizationId: string, { extra: { organizationService } }) => await organizationService.getCoturnCredentials(organizationId)
);
